import { getParameterByName } from './queryStringHelper';

/**
 * Detects whether the page is running inside the PayPal mobile app webview.
 * Checks for 'PayPalMobile' in the User-Agent, with a '?mobile' query
 * parameter as a QA/debug escape hatch.
 */
export function isFromMobileApp() {
  const userAgent =
    (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  return userAgent.includes('PayPalMobile') || getParameterByName('mobile') !== null;
}
